import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import classNames from 'classnames';

// Actions
import { mergeQuery } from 'modules/history/actions';
import SVG from 'components/widgets/icons/svg';

class SortableTHComponent extends React.Component {
  static propTypes = {
    sort: PropTypes.object.isRequired,
    sortField: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    text: PropTypes.string,
    children: PropTypes.any
  };

  constructor() {
    super();
    this.changeSort = this.changeSort.bind(this);
  }

  changeSort(field) {
    const { field: oldField, direction: oldDirection } = this.props.sort;
    let direction = 'DESC';

    if (field === oldField) direction = oldDirection === 'ASC' ? 'DESC' : 'ASC';

    mergeQuery({ sort: { field, direction } });
  }

  render() {
    const { sort, sortField, disabled, className, text, children, ...props } = this.props;
    const classes = ['m-0', 'position-relative'];
    const desc = sort.field === sortField && sort.direction === 'DESC';
    const asc = sort.field === sortField && sort.direction === 'ASC';

    return (
      <th
        {..._.omit(props, ['dispatch'])}
        className={classNames(className, 'sortable-header', { disabled })}
        onClick={disabled ? _.noop : () => this.changeSort(sortField)}
      >
        <div className="d-flex align-items-center">
          <div>{children || text}</div>
          <div style={{ height: '19px', top: '-10px' }} className="d-flex flex-column ml-1 position-relative">
            <SVG style={{ top: '5px' }} className={classNames(classes, { 'text-body': asc, 'text-silver': !asc })} src="svg/collapse.svg" />
            <SVG style={{ top: '-5px' }} className={classNames(classes, { 'text-body': desc, 'text-silver': !desc })} src="svg/expand.svg" />
          </div>
        </div>
      </th>
    );
  }
}

function mapStateToProps(state) {
  return { sort: state.location.query.sort || {} };
}

export default connect(mapStateToProps)(SortableTHComponent);
